<template>
    <div class="mainInner">
        <section class="side">
            <div class="bgfff mb20 side-1"
                 id="step-one">
                <h3 class="titleH3">最近玩过</h3>
                <!--<loading v-if="isLoadingHistory"/>-->
                <!--<div v-else>-->
                <div class="loginBtn"
                     v-if="!isLogined">
                    <div>
                        <img src="/resource/images/img_useravatar.png"
                             alt />
                    </div>
                    <a href="javascript:;"
                       class="btnLogin"
                       @click="fnBtnClick({type: 'showLogin'})">立即登录</a>
                    <div class="btnRegisterWraper">
                        <a href="javascript:;"
                           class="btnRegister"
                           @click="fnBtnClick({type: 'showRegister'})">注册账号</a>
                    </div>
                    <div class="loginTips">登录以后查看您最近玩过的游戏</div>
                </div>
                <div class="userPlayed"
                     v-else>
                    <ul class="list">
                        <template v-if="historyData.length > 0">
                            <li v-for="(item, index) in historyData"
                                :key="index">
                                <a href="javascript:;"
                                   class="item"
                                   @click="fnHistoryGame({
                    url: item.play_url,
                    orientation:item.orientation,
                    gameCode: item.game_code,
                    gameName: item.game_name,
                    serverName: item.server_name,
                    serverId: item.server_id,
                    gameType: item.game_type,
                    coreType: item.core_type,
                    idx: index + 1,
                    identify:item.identify,
                    prompt:item.adsData || ''
                  })">
                                    <div class="img">
                                        <img :src="item.logo"
                                             :alt="item.game_name" />
                                    </div>
                                    <div class="txt">
                                        <div class="gameName">{{item.game_name}}</div>
                                        <div class="gameServer">{{item.server_name}}</div>
                                    </div>
                                    <span class="btnPlayGame">进入游戏</span>
                                </a>
                            </li>
                        </template>
                        <li v-else>
                            <empty-data>还没有最近玩过，快去玩吧</empty-data>
                        </li>
                    </ul>
                    <a-pagination v-if="historyData.length > 0"
                                  :defaultCurrent="historyCurrentPage"
                                  :current="historyCurrentPage"
                                  hideOnSinglePage
                                  :defaultPageSize="4"
                                  :total="historyTotalPage"
                                  @change="changePage"
                                  size="small" />
                </div>
                <!--</div>-->
            </div>
            <div class="bgfff mb20 side-2 gameRank">
                <h3 class="titleH3">
                    热门
                    <span v-text="gameRankTypeTxt"></span>排行榜
                    <div class="gameRankSwitch">
                        <a href="javascript:;"
                           class="btnPrev"
                           @click="fnSwitchGameType">
                            <svg xmlns="http://www.w3.org/2000/svg"
                                 xmlns:xlink="http://www.w3.org/1999/xlink"
                                 width="8px"
                                 height="14px">
                                <path fill-rule="evenodd"
                                      fill="rgb(170, 170, 170)"
                                      d="M6.885,0.789 L1.158,6.516 L6.854,12.211 C7.040,12.397 7.040,12.699 6.854,12.885 C6.668,13.071 6.366,13.071 6.180,12.885 L0.153,6.859 C0.151,6.856 0.147,6.858 0.145,6.855 C0.140,6.851 0.139,6.845 0.135,6.840 L0.114,6.819 C-0.073,6.633 -0.073,6.331 0.114,6.145 C0.145,6.113 0.191,6.118 0.229,6.097 L6.211,0.115 C6.397,-0.071 6.699,-0.071 6.885,0.115 C7.071,0.301 7.071,0.603 6.885,0.789 Z" />
                            </svg>
                        </a>
                        <a href="javascript:;"
                           class="btnNext"
                           @click="fnSwitchGameType(1)">
                            <svg xmlns="http://www.w3.org/2000/svg"
                                 xmlns:xlink="http://www.w3.org/1999/xlink"
                                 width="8px"
                                 height="13px">
                                <path fill-rule="evenodd"
                                      fill="rgb(170, 170, 170)"
                                      d="M6.887,6.803 L6.866,6.824 C6.862,6.828 6.860,6.834 6.856,6.839 C6.853,6.841 6.850,6.840 6.847,6.842 L0.848,12.854 C0.662,13.040 0.362,13.040 0.177,12.854 C-0.009,12.668 -0.009,12.367 0.177,12.182 L5.847,6.500 L0.146,0.787 C-0.040,0.602 -0.040,0.300 0.146,0.115 C0.331,-0.071 0.631,-0.071 0.817,0.115 L6.772,6.082 C6.809,6.103 6.855,6.098 6.887,6.130 C7.072,6.316 7.072,6.617 6.887,6.803 Z" />
                            </svg>
                        </a>
                    </div>
                </h3>
                <loading v-if="isLoadingRank" />
                <div v-else>
                    <ul class="list"
                        v-if="gameRankData.length > 0">
                        <li v-for="(item, index) in gameRankData"
                            :key="index">
                            <a href="javascript:;"
                               class="item"
                               @click="fnPlayGame({
                  url: item.play_url,
                  orientation:item.orientation,
                  downloadurl:item.downloadurl,
                  gameName: item.game_name,
                  gameType: item.game_type,
                  gameCode: item.game_code,
                  openType: item.open_type,
                  idx: index + 1,
                  page_block_id: 3,
                  identify:item.identify,
                  launch:item.launch || ''
                })">
                                <div class="num">{{index + 1}}</div>
                                <div class="img">
                                    <img :src="item.logo_mini"
                                         alt />
                                </div>
                                <div class="txt">
                                    <div class="gameName"
                                         v-html="item.game_name"></div>
                                    <div class="txtWraper">
                                        <div class="tags">
                                            <span v-for="(tag, tagIndex) in item.tag_list"
                                                  :key="tagIndex">{{tag}}</span>
                                        </div>
                                        <div class="btnNml">进入游戏</div>
                                    </div>
                                </div>
                            </a>
                        </li>
                    </ul>
                    <ul class="list"
                        v-else>
                        <li>
                            <empty-data>暂无数据，请稍候再试</empty-data>
                        </li>
                    </ul>
                </div>
            </div>
            <div class="bgfff side-3 ad280x180">
                <loading v-if="isLoadingAds" />
                <div v-else>
                    <a v-if="adsData.image_url"
                       href="javascript:;"
                       @click="fnRoll({
              url: adsData.redirect_url,
              orientation: adsData.orientation,
              gameType: adsData.game_type,
              gameCode: adsData.game_code,
              gameName: adsData.game_name,
              serverName: adsData.server_name,
              serverId: adsData.server_id,
              openType: adsData.open_type,
              idx: 1,
              title: adsData.game_name,
              page_block_id: 4,
              coreType: adsData.core_type,
              identify: adsData.identify,
              prompt:adsData.adsData
            })">
                        <img :src="adsData.image_url"
                             :alt="adsData.game_code" />
                    </a>
                </div>
            </div>
        </section>
        <section class="wide">
            <section class="bgfff mb20 slider">
                <loading v-if="isLoadingSwiper" />
                <div v-else>
                    <div class="swiper-container">
                        <div class="swiper-wrapper">
                            <div class="swiper-slide"
                                 v-for="(item, index) in swiperData"
                                 :key="index">
                                <a href="javascript:;">
                                    <!-- @click="fnRoll({url: item.redirect_url, gameType: item.game_type, gameCode: item.game_code, gameName: item.game_name, openType: item.open_type})" -->
                                    <img :src="item.image_url"
                                         :alt="item.title"
                                         :data-idx="index" />
                                </a>
                            </div>
                        </div>
                        <!-- 如果需要分页器 -->
                        <div class="swiper-pagination"></div>

                        <!-- 如果需要导航按钮 -->
                        <div class="swiper-button-prev"></div>
                        <div class="swiper-button-next"></div>
                    </div>
                </div>
            </section>
            <section class="mb20 recommend">
                <h3 class="titleH3">
                    推荐游戏
                    <a href="javascript:;"
                       @click="fnGetRecommend"
                       class="btnSwitchRecommend">
                        <svg xmlns="http://www.w3.org/2000/svg"
                             xmlns:xlink="http://www.w3.org/1999/xlink"
                             width="21px"
                             height="14px">
                            <path fill-rule="evenodd"
                                  fill="rgb(136, 136, 136)"
                                  d="M19.856,5.880 L16.912,8.823 C16.803,8.932 16.658,8.978 16.516,8.970 C16.373,8.978 16.228,8.932 16.119,8.823 L13.175,5.880 C12.972,5.677 12.972,5.347 13.175,5.144 C13.378,4.941 13.708,4.941 13.911,5.144 L15.979,7.212 C15.982,7.140 16.000,7.072 16.000,7.000 C16.000,3.686 13.314,1.000 10.000,1.000 C8.230,1.000 6.655,1.781 5.557,3.000 L4.260,3.000 C5.525,1.188 7.622,-0.000 10.000,-0.000 C13.866,-0.000 17.000,3.134 17.000,7.000 C17.000,7.098 16.982,7.191 16.977,7.287 L19.120,5.144 C19.323,4.941 19.653,4.941 19.856,5.144 C20.059,5.347 20.059,5.677 19.856,5.880 ZM6.825,8.856 C6.621,9.059 6.292,9.059 6.089,8.856 L4.021,6.788 C4.018,6.860 4.000,6.927 4.000,7.000 C4.000,10.314 6.686,13.000 10.000,13.000 C11.770,13.000 13.345,12.219 14.443,11.000 L15.740,11.000 C14.475,12.812 12.378,14.000 10.000,14.000 C6.134,14.000 3.000,10.866 3.000,7.000 C3.000,6.902 3.018,6.809 3.023,6.713 L0.880,8.856 C0.677,9.059 0.347,9.059 0.144,8.856 C-0.059,8.653 -0.059,8.323 0.144,8.120 L3.088,5.177 C3.197,5.067 3.342,5.022 3.484,5.030 C3.627,5.022 3.772,5.067 3.881,5.177 L6.825,8.120 C7.028,8.323 7.028,8.653 6.825,8.856 Z" />
                        </svg>
                        换一换
                    </a>
                </h3>
                <loading v-if="isLoadingRecommend" />
                <div v-else>
                    <ul class="list">
                        <li v-for="(item, index) in gameRecommendData"
                            :key="index">
                            <a href="javascript:;"
                               @click="fnRoll({
                  url: item.redirect_url,
                  orientation:item.orientation,
                  coreType:item.core_type,
                  downloadurl:item.downloadurl,
                  gameType: item.game_type,
                  gameCode: item.game_code,
                  gameName: item.game_name,
                  serverName: item.server_name,
                  serverId: item.server_id,
                  openType: item.open_type,
                  idx: index + 1,
                  title: item.game_name,
                  page_block_id: 6,
                  identify:item.identify,
                  prompt:item.prompt,
                  launch:item.launch || ''
                })">
                                <img :src="item.logo_recommend"
                                     :alt="item.game_name" />
                                <div class="txt">
                                    <div class="tags"
                                         :class="item.flag_type === 1 ? 'tagsHot' : 'tagsNew'"
                                         v-if="item.flag_type !== 0">
                                        <span>{{item.flag_text}}</span>
                                    </div>
                                    <div class="txtWraper">
                                        <div class="gameName">{{item.game_name}}</div>
                                        <div class="gameDesc">{{item.tips}}</div>
                                        <span class="btnPlayGame">进入游戏</span>
                                    </div>
                                </div>
                            </a>
                        </li>
                    </ul>
                </div>
            </section>
            <section class="hot"
                     id="step-two">
                <h3 class="titleH3">热门游戏</h3>
                <div class="tabs">
                    <a href="javascript:;"
                       @click="fnTabSwitch(1, '网页游戏')"
                       :class="tabActive === 1 ? 'active' : ''">网页游戏</a>
                    <a href="javascript:;"
                       @click="fnTabSwitch(2, '网络游戏')"
                       :class="tabActive === 2 ? 'active' : ''">网络游戏</a>
                    <a href="javascript:;"
                       @click="fnTabSwitch(3, '手机游戏')"
                       :class="tabActive === 3 ? 'active' : ''">手机游戏</a>
                    <a href="javascript:;"
                       @click="fnTabSwitch(4, 'H5游戏')"
                       :class="tabActive === 4 ? 'active' : ''">H5游戏</a>
                </div>
                <game-list :listData="gameHotListData"
                           @fnBtnClick="fnPlayGame" />
            </section>
        </section>
    </div>
</template>

<script>
import store from '../store'
import Swiper from 'swiper'
import Loading from '@/common/Loading'
import EmptyData from '@/common/EmptyData'
import GameList from '@/components/GameList'
import fnOpen from '@/util/qktd'
import { encode } from 'js-base64'
export default {
    name: 'HomeMain',
    data () {
        return {
            wndNmlMax: false,
            isFullScreen: false,
            classWndNmlMax: 'classWndNml',
            isLogined: store.state.USER.uid,
            historyData: [],
            rankGameType: 1,
            gameRankData: [],
            swiperData: [],
            gameRecommendData: [],
            gameHotData: [],
            gameHotListData: [],
            adsData: {},
            isLoadingRank: true,
            isLoadingAds: true,
            isLoadingHistory: true,
            isLoadingSwiper: true,
            isLoadingRecommend: true,
            isLoadingHot: true,
            mySwiper: null,
            tabActive: 1,
            btnFastClick: false,
            recommendNum: 1,
            USER: {
                uid: '',
                passport: ''
            },
            startRecordTimer: null,
            endRecordTimer: null,
            gameRankTypeTxt: '页游',
            ishall: false,
            visible: true,
            historyCurrentPage: 1,
            historyTotalPage: 1
        }
    },
    components: {
        Loading,
        EmptyData,
        GameList
    },
    computed: {
        login () {
            return store.state.USER.uid
        },
        historyUpdate () {
            return store.state.historyUpdate
        },
        refreshGameData () {
            return store.state.reFreshPageData
        }
    },
    watch: {
        gameHotData () {
            this.gameHotListData = this.gameHotData
        },
        login (n, o) {
            this.fnIsLogined(n)
        },
        historyUpdate (n, o) {
            this.historyCurrentPage = 1
            this.fnRecently()
        },
        refreshGameData (n, o) {
            this.fnRefreshGameData()
        }
    },
    beforeCreate () {
        localStorage.setItem('startRecordTimer', Date.now())
    },
    created () {
    },
    mounted () {
        var t = this
        // 获取用户信息
        t.Storage.get('USER', (res) => {
            t.USER = res.data.USER
        })
        // 右侧轮播
        t.fnSwiper(function () {
            t.$nextTick(function () {
                t.fnSwiperInit()
            })
        })
        // 左侧最近玩过
        if (t.isLogined) t.fnRecently()
        // 发送PV统计
        t.$nextTick(() => {
            t.endRecordTimer = Date.now()
            t.DSP.pv({
                opentime: Number(t.endRecordTimer) - Number(localStorage.getItem('startRecordTimer')),
                uid: t.USER.uid
            })
        })
        // 大厅判断逻辑
        t.fnCefGameBox({
            method: 'IsHall',
            success: res => {
                if (res.data.isHall === 1) {
                    t.isHall = true
                } else {
                    t.isHall = false
                }
            }
        })
    },
    methods: {
        // 刷新页面数据
        fnRefreshGameData () {
            // 最近玩过
            this.fnRecently()
            // 左下角广告数据
            this.fnAdsRecommend()
            // 右侧推荐游戏
            this.fnGameRecommend()
            // 热门排行榜及切换
            this.fnSwitchGameType(0)
            // 热门游戏数据
            this.fnGameHot(1)
            // 轮播数据
            this.fnSwiper(1)
        },
        // 玩过的游戏打开方式
        async fnHistoryGame (o) {
            let t = this
            if (t.btnFastClick) return
            t.btnFastClick = true
            // t.fnPlayGame(o)
            if (!o.url) {
                t.Toast({
                    content: o.prompt || '该游戏区服维护中，请稍后再进入游戏',
                    time: 5000
                })
            }
            let windowTitle = o.gameName
            if (o.serverName) {
                windowTitle += ' | ' + o.serverName
            }
            if (this.$store.state.USER.passport) {
                if (!t.$store.state.USER.isVistor) {
                    windowTitle += ' | ' + this.$store.state.USER.passport
                }
            } else {
                this.$store.commit('FNSTATE', {
                    showLogin: true
                })
                return
            }
            let e = event
            if (!e) {
                e = {
                    clientX: 0,
                    clientY: 0
                }
            }
            let d = {
                url: o.url,
                width: 1400,
                height: 840,
                type: o.coreType,
                window_title: windowTitle || '易乐玩游戏盒子',
                game_name: o.gameName,
                game_code: o.gameCode,
                server_name: o.serverName || '',
                server_id: o.serverId || '',
                passport: this.$store.state.USER.passport,
                uid: this.$store.state.USER.uid
            }
            if (o.gameType === 4 && o.orientation) {
                d.width = 500
                d.height = 850
            }
            if (o.coreType === 2 && o.gameType === 1 && t.$store.state.USER.isVistor) {
                d.url = "http://box.yilewan.com/webGame.html?url=" + encodeURIComponent(o.url)
            }
            if (o.gameType !== 4) {
                d.url = 'https://box-api.yilewan.com/accessGame/playTo?url=' + Base64.encode(o.url) + '&uid=' + this.$store.state.USER.uid + '&game_code=' + o.gameCode + '&passport=' + this.$store.state.USER.passport
            }
            this.fnCefGameBox({
                method: 'clientOpenWnd',
                data: d,
                success: r => {
                    t.btnFastClick = false
                    t.DSP.click({
                        type: 1,
                        pars: o.gameCode + '_' + o.serverId,
                        url: d.url,
                        sourcename: o.gameName,
                        id: o.idx || o.serverId,
                        page_block_id: 2,
                        x_position: e.clientX,
                        y_position: e.clientY
                    })
                    if (o.gameType === 1) {
                        let loginType = 1
                        if (this.$cookies.get('login_type') === 'phone') {
                            loginType = 2
                        }
                        if (this.$cookies.get('login_type') === 'qq') {
                            loginType = 3
                        }
                        if (this.$cookies.get('login_type') === 'weixin') {
                            loginType = 5
                        }
                        if (this.$cookies.get('login_type') === 'weibo') {
                            loginType = 4
                        }
                        this.DSP.login({
                            dataType: 'login',
                            uid: this.$store.state.USER.uid,
                            passport: this.$store.state.USER.passport,
                            type: loginType,
                            login_type: 2,
                            game: o.gameCode,
                            server: o.serverId
                        })
                        ELSDK.SDKAPI(
                            'tjlogin',
                            {
                                uid: this.$store.state.USER.uid,
                                source_page: 'yilewan_pcbox',
                                attr: o.gameCode ? 'game' : '',
                                attr_value: o.gameCode ? o.gameCode : '',
                                game_code: o.gameCode ? o.gameCode : ''
                            },
                            (res) => { })
                    }
                }
            })
        },
        // 登录判断
        fnIsLogined (n) {
            if (!store.state.USER.uid) {
                this.isLogined = false
            } else {
                this.isLogined = true
                this.fnRecently()
            }
        },
        // 用户判断是否实名、成年、未成年，是否可玩
        underAge(isCheck){
            let t = this
            return new Promise((resolve, reject) => {
                    t.XHR({
                        url: t.ports.user.underAge,
                        config: { withCredentials: true },
                        cbFn: res_ => {
                            if (res_.status === 'error') {
                                // t.Toast({
                                //     content: res_.info
                                // })
                            } else {
                                if (isCheck) {
                                    if (!res_.data.adult&&res_.data.canPlay === 3) {
                                        t.fnCefGameBox({
                                            method: 'clientOpenWnd',
                                            data: {
                                                url: 'https://account-api.yilewan.com/statics/aas/box.html',
                                                topmost: 1,
                                                status: 0,
                                                width: window.screen.width - 300,
                                                height: window.screen.height - 500
                                            },
                                            success: res => {}
                                        })
                                    }
                                    if (!res_.data.adult&&res_.data.canPlay === 1) {
                                        setTimeout(t.underAge, 60*1e3)
                                    }
                                }
                                resolve(res_)
                            }
                        }
                    })
                })
        },
        // 实名判断
        isIdentify (type, gameidentify, opentype) {
            let t = this
            // if (type === 1 && gameidentify && opentype && !t.$store.state.USER.isVistor) {
            if (type === 1 && gameidentify && opentype) {
                return new Promise((resolve, reject) => {
                    t.XHR({
                        url: t.ports.user.isIdentify,
                        config: { withCredentials: true },
                        cbFn: res_ => {
                            if (res_.status === 'error') {
                                t.Toast({
                                    content: res_.info
                                })
                            } else {
                                resolve(res_)
                            }
                        }
                    })
                })
            }
        },
        // 选项卡切换
        fnTabSwitch (type, name) {
            this.isLoadingHot = true
            this.tabActive = type
            this.fnGameHot(type)
            this.DSP.click({
                type: 7,
                pars: '',
                url: '',
                sourcename: name,
                id: type,
                page_block_id: 7,
                x_position: event.clientX,
                y_position: event.clientY
            })
        },
        // 左下角广告数据
        fnAdsRecommend () {
            this.XHR({
                url: this.ports.ads.recommend,
                method: 'get',
                cbFn: (res) => {
                    this.isLoadingAds = false
                    if (res.status === 'error') {
                        return
                    }
                    this.adsData = res.data.info
                    this.$store.commit('FNSTATE', {
                        ADSHALL: res.data
                    })
                }
            })
        },
        // 热门游戏数据
        fnGameHot (type) {
            this.XHR({
                url: this.ports.home.hot,
                method: 'get',
                data: {
                    game_type: type || 1
                },
                cbFn: (res) => {
                    this.isLoadingHot = false
                    if (res.status === 'error') return
                    this.gameHotData = res.data.list
                }
            })
        },
        // 推荐游戏数据
        fnGameRecommend (num) {
            this.isLoadingRecommend = true
            this.XHR({
                url: this.ports.home.recommend,
                data: {
                    num: num || 1
                },
                cbFn: (res) => {
                    if (this.gameHotData.length < 1) {
                        // 右侧热门游戏
                        this.fnGameHot()
                    }
                    this.gameRecommendData = res.data.list
                    this.isLoadingRecommend = false
                }
            })
        },
        // 推荐游戏-换一换功能
        fnGetRecommend () {
            this.recommendNum = this.recommendNum + 1
            this.fnGameRecommend(this.recommendNum)
            this.DSP.click({
                type: 7,
                pars: '',
                url: '',
                sourcename: '推荐游戏-换一换',
                id: 6001,
                page_block_id: 6,
                x_position: event.clientX,
                y_position: event.clientY
            })
        },
        // 轮播数据
        fnSwiper (fn) {
            this.XHR({
                url: this.ports.ads.roll,
                method: 'get',
                cbFn: (res) => {
                    // 右侧推荐游戏
                    this.fnGameRecommend()
                    this.swiperData = res.data
                    this.isLoadingSwiper = false
                    if (typeof fn === 'function') {
                        fn()
                        // 热门排行榜及切换
                        this.fnSwitchGameType(0)
                        // 左下角广告
                        this.fnAdsRecommend()
                    }
                }
            })
        },
        // 轮播初始化
        fnSwiperInit () {
            let t = this
            this.mySwiper = new Swiper(
                '.swiper-container',
                {
                    initialSlide: 0,
                    observer: true,
                    observeParents: true,
                    autoplay: 5000,
                    loop: true,
                    // 如果需要分页器
                    pagination: '.swiper-pagination',
                    // 如果需要前进后退按钮
                    nextButton: '.swiper-button-next',
                    prevButton: '.swiper-button-prev',
                    onClick: (swiper, event) => {
                        // let dataset = event.target
                        let item = t.swiperData[event.target.dataset.idx]
                        if (!item) return
                        if (item.open_type && item.open_type === 5 && !t.isLogined) {
                            t.$message.error('请先登录后再玩游戏')
                            t.$store.commit('FNSTATE', {
                                showLogin: true
                            })
                            return
                        }
                        t.fnRoll({
                            url: item.redirect_url,
                            downloadurl: item.downloadurl,
                            gameType: item.game_type,
                            gameCode: item.game_code,
                            gameName: item.game_name,
                            serverName: item.server_name,
                            serverId: item.server_id,
                            openType: item.open_type,
                            coreType: item.core_type,
                            title: item.title,
                            idx: event.target.dataset.idx,
                            page_block_id: 5,
                            clientX: event.clientX,
                            clientY: event.clientY,
                            identify: item.identify,
                            prompt: item.prompt,
                            launch: item.launch || ''
                        })
                    }
                })
        },
        // 最近玩过的游戏数据
        fnRecently () {
            this.XHR({
                url: this.ports.home.history,
                data: {
                    token: store.state.USER.box_token,
                    page: this.historyCurrentPage
                },
                cbFn: (res) => {
                    if (!res || res.status === 'error') return
                    this.historyData = res.data.list || ''
                    this.historyTotalPage = Number(res.data.count)
                    this.isLoadingHistory = false
                    // this.isLogined = true
                }
            })
        },
        changePage (page, pageSize) {
            let t = this
            if (page === t.historyCurrentPage) {
                return false
            }
            t.historyCurrentPage = page
            this.fnRecently()
        },
        // 轮播点击事件
        fnRoll (o) {
            switch (o.openType) {
                // 轮播类型1|游戏，2|内容，3|无操作，4|外跳，5|进游戏最新服，6|启端
                case 1:
                case 5:
                    if ((o.game_code || o.gameCode).toLowerCase() === 'qktd') {
                        fnOpen(o, this)
                        return
                    }
                    if (!o.url) {
                        this.Toast({
                            content: o.prompt || '该游戏区服维护中，请稍后再进入游戏',
                            time: 5000
                        })
                        return
                    }
                    this.fnPlayGame(o)
                    return
                    // eslint-disable-next-line
                    break
                case 2:
                    if (!this.isHall) return
                    this.Storage.get('wndBrowser', (j) => {
                        if (j.data.wndBrowser) {
                            this.$store.commit('FNSTATE', {
                                browserUrl: this.fnFormatUrl(o.url)
                            })
                            this.fnCefGameBox({
                                method: 'SendJsMsg',
                                data: {
                                    method: 'wndBrowser',
                                    data: {
                                        url: this.fnFormatUrl(o.url)
                                    }
                                }
                            })
                        } else {
                            this.fnCefGameBox({
                                method: 'clientOpenWnd',
                                data: {
                                    url: o.url,
                                    type: 0
                                },
                                success: res => {
                                    this.Storage.set('wndBrowser', 1, (res) => { })
                                }
                            })
                        }
                    })
                    break
                case 3:
                    break
                case 4:
                    this.fnCefGameBox({
                        method: 'clientOpenBrowser',
                        data: {
                            url: o.url,
                            type: 1
                        }
                    })
                    break
                case 6:
                    if ((o.game_code || o.gameCode).toLowerCase() === 'qktd') {
                        fnOpen(o, this)
                        return
                    }
                    this.fnOpenLocalClient(o.url, o.downloadurl)
                    break
            }
            let openType = o.openType || o.gameType
            if (o.openType && o.openType === 1) {
                openType = 13
            }
            if (o.openType && o.openType === 5) {
                openType = 1
            }
            this.DSP.click({
                type: openType,
                pars: o.gameCode,
                url: o.url,
                sourcename: o.title || o.game_name,
                id: o.idx,
                page_block_id: o.page_block_id,
                x_position: event ? event.clientX : o.clientX,
                y_position: event ? event.clientY : o.clientY
            })
        },
        // 打开本地客户端
        fnOpenLocalClient (url, downloadurl) {
            // 判断游戏资源是否存在
            if (this.fnClientInfo('gid') && Number(this.fnClientInfo('gid')) < 99999999 && Number(this.fnClientInfo('gid')) > 1) {
                if (url.indexOf('?') > -1) {
                    url = url + '&ts='
                } else {
                    url = url + '?ts='
                }
                new Image(1, 1).src = url + Date.now()
                this.Toast({
                    content: '正在启动游戏，请稍候。',
                    time: 5000
                })
            } else {
                this.fnCefGameBox({
                    method: 'clientOpenBrowser',
                    data: {
                        url: downloadurl,
                        type: 1
                    }
                })
            }
        },
        // 窗口打开逻辑判断
        async fnPlayGame (o) {
            let t = this
            // 乾坤天地处理
            if ((o.game_code || o.gameCode).toLowerCase() === 'qktd') {
                fnOpen(o, this)
                return
            }
            // 1|页游 2|端游 3|手游 4|H5
            switch (o.gameType) {
                case 1:
                    break
                case 2:
                case 3:
                    this.fnOpenLocalClient(o.url, o.downloadurl)
                    if (this.fnClientInfo('gid') && parseInt(this.fnClientInfo('gid')) < 0) {
                        o.url = o.downloadurl
                    }
                    this.DSP.click({
                        type: 6,
                        pars: o.url,
                        url: o.url,
                        sourcename: o.gameName,
                        id: o.idx || o.serverId,
                        page_block_id: o.page_block_id,
                        x_position: event.clientX,
                        y_position: event.clientY
                    })
                    break
                case 4:
                    o.type = 0
                    break
            }
            if (o.gameType === 2 || o.gameType === 3) return
            let windowTitle = o.gameName
            if (o.serverName) {
                windowTitle += ' | ' + o.serverName
            }
            if (this.$store.state.USER.passport) {
                if (!this.USER.isVistor) {
                    windowTitle += ' | ' + this.$store.state.USER.passport
                }
            } else {
                this.$store.commit('FNSTATE', {
                    showLogin: true
                })
                return
            }
            let e = event
            if (!e) {
                e = {
                    clientX: 0,
                    clientY: 0
                }
            }
            let type = o.openType
            let sType = 13
            if (!type) {
                type = 0
                if (o.gameType) {
                    switch (o.gameType) {
                        case 1:
                            sType = 13
                            break
                        case 4:
                            sType = 1
                            break
                        case 2:
                        case 3:
                            sType = 6
                            break
                    }
                }
            } else {
                if (type === 1) {
                    sType = 13
                }
                if (type === 5) {
                    sType = 1
                }
            }
            let pars = o.gameCode
            if (o.serverId) {
                pars += '_' + o.serverId
            }
            this.DSP.click({
                type: sType,
                pars: pars || o.url,
                url: o.url,
                sourcename: o.gameName,
                id: o.idx || o.serverId,
                page_block_id: o.page_block_id,
                x_position: e.clientX,
                y_position: e.clientY
            })
            let open = 0
            // 轮播类型1|游戏，2|内容，3|无操作，4|外跳，5|进游戏最新服，6|启端
            if (o.openType && o.openType === 5 && o.coreType && o.coreType === 2) {
                open = 2
            }
            let d = {
                url: o.url,
                width: 1400,
                height: 840,
                type: open,
                window_title: windowTitle || '易乐玩游戏盒子',
                game_name: o.gameName,
                game_code: o.gameCode,
                server_name: o.serverName || '',
                server_id: o.serverId || '',
                passport: this.$store.state.USER.passport,
                uid: this.$store.state.USER.uid
            }
            if (o.gameType === 4 && o.orientation) {
                d.width = 500
                d.height = 850
            }
            let open_ = (o.openType && o.openType === 5) ? 1 : 0
            if (o.gameType !== 4) {
                d.url = 'https://box-api.yilewan.com/accessGame/playTo?url=' + Base64.encode(o.url) + '&uid=' + this.$store.state.USER.uid + '&game_code=' + o.gameCode + '&passport=' + this.$store.state.USER.passport
            }
            this.fnCefGameBox({
                method: 'clientOpenWnd',
                data: d,
                success: res => {
                    if (o.gameType === 1 && o.openType === 5) {
                        let loginType = 1
                        if (this.$cookies.get('login_type') === 'phone') {
                            loginType = 2
                        }
                        if (this.$cookies.get('login_type') === 'qq') {
                            loginType = 3
                        }
                        if (this.$cookies.get('login_type') === 'weixin') {
                            loginType = 5
                        }
                        if (this.$cookies.get('login_type') === 'weibo') {
                            loginType = 4
                        }
                        this.DSP.login({
                            dataType: 'login',
                            uid: this.$store.state.USER.uid,
                            passport: this.$store.state.USER.passport,
                            type: loginType,
                            login_type: 2,
                            game: o.gameCode,
                            server: o.serverId
                        })
                        ELSDK.SDKAPI(
                            'tjlogin',
                            {
                                uid: this.$store.state.USER.uid,
                                source_page: 'yilewan_pcbox',
                                attr: o.gameCode ? 'game' : '',
                                attr_value: o.gameCode ? o.gameCode : '',
                                game_code: o.gameCode ? o.gameCode : ''
                            },
                            (res) => { })
                    }
                }
            })
        },
        // 切换游戏类型
        fnSwitchGameType (type) {
            this.isLoadingRank = true
            if (type !== 0) {
                if (type === 1) {
                    this.rankGameType++
                } else {
                    this.rankGameType--
                }
                if (this.rankGameType > 4) {
                    this.rankGameType = 1
                }
                if (this.rankGameType < 1) {
                    this.rankGameType = 4
                }
                if (this.rankGameType === 1) {
                    this.gameRankTypeTxt = '页游'
                }
                if (this.rankGameType === 2) {
                    this.gameRankTypeTxt = '端游'
                }
                if (this.rankGameType === 3) {
                    this.gameRankTypeTxt = '手游'
                }
                if (this.rankGameType === 4) {
                    this.gameRankTypeTxt = 'H5'
                }
                this.DSP.click({
                    type: 7,
                    pars: '',
                    url: '',
                    sourcename: this.gameRankTypeTxt,
                    id: this.rankGameType,
                    page_block_id: 3,
                    x_position: event.clientX,
                    y_position: event.clientY
                })
            }
            this.XHR({
                url: this.ports.home.rank,
                method: 'get',
                data: {
                    game_type: this.rankGameType
                },
                cbFn: (res) => {
                    if (res.status === 'error') return
                    this.gameRankData = res.data.list
                    this.isLoadingRank = false
                }
            })
        },
        // 按钮点击事件
        fnBtnClick (o) {
            switch (o.type) {
                case 'wndMin':
                    break
                case 'wndNmlMax':
                    this.wndNmlMax = !this.wndNmlMax
                    break
                case 'wndClose':
                    break
                case 'openWnd':
                    break
                case 'fullScreen':
                    break
                case 'openBrowser':
                    break
                case 'showLogin':
                    this.$store.commit('FNSTATE', {
                        showLogin: true
                    })
                    this.DSP.click({
                        type: 0,
                        pars: '',
                        url: location.protocol + '//account.yilewan.com/statics/authorize/#/',
                        sourcename: '立即登录',
                        id: 0,
                        page_block_id: 2,
                        x_position: event.clientX,
                        y_position: event.clientY
                    })
                    break
                case 'showRegister':
                    this.$store.commit('FNSTATE', {
                        showRegister: true
                    })
                    this.DSP.click({
                        type: 0,
                        pars: '',
                        url: location.protocol + '//account.yilewan.com/statics/authorize/#/?logType=register',
                        sourcename: '注册账号',
                        id: 1,
                        page_block_id: 2,
                        x_position: event.clientX,
                        y_position: event.clientY
                    })
                    break
            }
        },
        fnClientInfo (k) {
            let wci = JSON.parse(window.clientInfo)
            if (wci[k]) {
                return wci[k]
            } else {
                return ''
            }
        },
        // 格式化url
        fnFormatUrl (u) {
            if (u.indexOf('url=') > -1) {
                u = decodeURIComponent(u.split('url=')[1])
            }
            return u
        },
    }
}
</script>

<style scoped>
.ant-pagination {
  text-align: center;
}
/deep/ .ant-pagination-item-active {
  border: none;
}
</style>
